import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import AxiosInstance from '../../../helpers/AxiosInstance';
import { useHistory, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const useForm = (optionsToDisplay) => {
  const { addButton, editAction, deleteAction } = optionsToDisplay;

  const [listEstablishment, setListEstablishment] = useState([]);
  const [totalItems, setTotalItems] = useState(null);
  const [totalPages, setTotalPages] = useState(null);
  const [loading, setLoading] = useState(false);
  const [establishmentIsActivited, setEstablishmentIsActivited] = useState('');
  const [region, setRegion] = useState('');
  const history = useHistory();
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const [query, setQuery] = useState({ page: null, order: '', keyword: '', limit: 10 });

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const page = parseInt(queryParams.get('page'));
    const order = queryParams.get('order');
    const keyword = queryParams.get('keyword');
    setQuery((prev) => ({
      ...prev,
      page: page ? page - 1 : 0,
      order: order ? order : query.order,
      keyword: keyword ? keyword : '',
    }));
  }, [location]);

  useEffect(() => {
    if (query.page !== null) {
      findAllEstablishment();
    }
  }, [query, establishmentIsActivited, region]);

  const findAllEstablishment = () => {
    setLoading(true);
    AxiosInstance.get('/establishment', { params: { ...query, isActivited: establishmentIsActivited, region: region } })
      .then((response) => {
        setListEstablishment(response.data.items);
        setTotalPages(response.data.totalPages);
        setTotalItems(response.data.totalItems);
        setLoading(false);
      })
      .catch((error) => {
        Swal.fire(t('establishment.ERROR_GET_ESTABLISHMENTS'), '', 'error');
        setLoading(false);
      });
  };

  const updateEstablishment = (id) => {
    history.push({
      pathname: '/establishment/update',
      params: {
        id: id,
      },
    });
  };

  const deleteEstablishment = (id) => {
    Swal.fire({
      title: t('swal.are_you_sure'),
      text: t('swal.delete_permanently'),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: t('swal.yes_delete'),
      cancelButtonText: t('swal.no'),
    }).then((result) => {
      if (result.isConfirmed) {
        AxiosInstance.delete('/establishment/' + id)
          .then((response) => {
            Swal.fire(t('establishment.SUCCESS_DELETE_ESTABLISHMENT'), '', 'success');
            findAllEstablishment();
          })
          .catch((error) => {
            Swal.fire(t('establishment.ERROR_DELETE_ESTABLISHMENT'), '', 'error');
          });
      }
    });
  };

  const attributes = [
    { name: 'name', title: t('table.name'), nestedObject: [], type: 'text', order: true },
    { name: 'category', title: t('table.category'), nestedObject: [], type: 'text', order: true, translate: true },
    { name: 'region', title: t('table.region'), nestedObject: [], type: 'text', order: true, translate: true },
    { name: 'email', title: t('table.email'), nestedObject: [], type: 'text', order: true },
    { name: 'phone', title: t('table.phone'), nestedObject: [], type: 'text', order: false },
    { name: 'status', title: t('table.status'), nestedObject: ['contract'], type: 'contract_status', order: false },
    //{ name: 'creationDate', title: t('table.creationDate'),  type: 'date', order: false },
  ];

  const actions = { details: null, delete: deleteAction && deleteEstablishment, update: editAction && updateEstablishment };

  return {
    attributes,
    actions,
    listEstablishment,
    findAllEstablishment,
    totalPages,
    loading,
    query,
    establishmentIsActivited,
    setEstablishmentIsActivited,
    region,
    setRegion,
  };
};

export default useForm;
